export default __webpack_public_path__ + "static/media/speaker.39577392.png";